import { useMediaQuery } from 'react-responsive';
import { ScreenWidthMinXXXLarge, ScreenWidthMaxXXLarge, ScreenWidthMinXXLarge, ScreenWidthMaxXLarge, ScreenWidthMinXLarge, ScreenWidthMaxLarge, ScreenWidthMinLarge, ScreenWidthMaxMedium, ScreenWidthMinMedium, ScreenWidthMaxSmall, ScreenWidthMinSmall, getScreenSelector } from '@fluentui/react';
import { useHydration } from './useHydration.esm.js';

var BREAKPOINTS = {
    sm: {
        min: ScreenWidthMinSmall,
        max: ScreenWidthMaxSmall
    },
    md: {
        min: ScreenWidthMinMedium,
        max: ScreenWidthMaxMedium
    },
    lg: {
        min: ScreenWidthMinLarge,
        max: ScreenWidthMaxLarge
    },
    xl: {
        min: ScreenWidthMinXLarge,
        max: ScreenWidthMaxXLarge
    },
    xxl: {
        min: ScreenWidthMinXXLarge,
        max: ScreenWidthMaxXXLarge
    },
    xxxl: {
        min: ScreenWidthMinXXXLarge
    }
};
// TODO: screen size should be sent via context after parsing user-agent
var SSR_DEFAULT = ScreenWidthMinXXXLarge;
function useBreakpoint(min, max) {
    var isHydrated = useHydration();
    var maxWidth = max ? BREAKPOINTS[max].max : BREAKPOINTS[min].max;
    var minWidth = BREAKPOINTS[min].min;
    var isMatching = useMediaQuery({
        minWidth: minWidth,
        maxWidth: maxWidth
    }, isHydrated ? undefined : {
        width: SSR_DEFAULT
    });
    return [
        isMatching,
        getScreenSelector(minWidth, maxWidth)
    ];
}

export { useBreakpoint };
